import { classes } from 'html-classes';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { useGlobal } from '~/hooks/useGlobal';

import styles from './Buttons.module.scss';

const Terms = () => {
  const { isMobile } = useGlobal();
  const { t } = useTranslation();

  const text = isMobile
    ? t('loyalty:buttons:termsShort')
    : t('loyalty:buttons:terms');

  return (
    <Link to="/legals" className={classes([styles.terms, 'button _white'])}>
      {text}
    </Link>
  );
};

export default Terms;
